// extracted by mini-css-extract-plugin
export default {"toast-display":"ToastDisplay_style__toast-display___d2"};